'use client';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { tv } from 'tailwind-variants';

import { faXmark } from '@icons/classic/regular';
import { FlexContainer } from '../components';
import { Body } from '../typography';

import type { VariantProps } from 'tailwind-variants';

const appliedFilterChip = tv({
  base: 'gap-1.5 rounded-sm bg-background-secondary text-primary',
  variants: {
    size: {
      sm: 'min-h-6 px-2.5',
      md: 'min-h-8 px-3',
      lg: 'min-h-10 px-4',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

export interface AppliedFilterChipProps extends VariantProps<typeof appliedFilterChip> {
  label: string;
  onClear: () => void;
  clearLabel: string;
  className?: string;
}

export function AppliedFilterChip({ label, onClear, clearLabel, className, size }: AppliedFilterChipProps) {
  return (
    <FlexContainer className={appliedFilterChip({ size, className })} items="center">
      <Body size="sm" weight="medium">
        {label}
      </Body>
      <button className="cursor-pointer" aria-label={clearLabel} onClick={onClear} type="button">
        <FontAwesomeIcon className="size-3" icon={faXmark} />
      </button>
    </FlexContainer>
  );
}
